import cameraScanning from "./everything-camera-scanning";
import movedByEggleston from "./moved-by-eggleston";
import gregGirardComparison from "./greg-girard-comparison";

const BLOG_POSTS = [gregGirardComparison, movedByEggleston, cameraScanning];

export default BLOG_POSTS;